<template>
    <div class="menu-outline mb-3">
        <ul class="horizontal-list d-flex justify-content-between d-lg-none">
            <li>
                <router-link to="/about" title="貸し本棚の使い方やメリットなどをご紹介">
                    貸し本棚ガイド
                </router-link>
            </li>
            <li>
                <router-link to="/notices" title="運営からのお知らせ一覧">
                    お知らせ
                </router-link>
            </li>
            <li>
                <router-link to="/contact" title="ご質問・不具合・要望など">
                    お問い合わせ
                </router-link>
            </li>
            <li>
                <router-link to="/help" title="貸し本棚の使い方">
                    ヘルプ
                </router-link>
            </li>
        </ul>
        <div class="btn-group btn-block mt-3" v-if="!isLoggedIn">
            <a href="/register" class="btn btn-dark">
                ユーザー登録
            </a>
            <a href="/login" class="btn btn-dark">
                ログイン
            </a>
        </div>
    </div>
</template>

<style scoped lang="scss">
.menu-outline {
    margin-top: 3.6rem;
    padding: 0 1rem;
    .menu {
        background-size: cover;
        max-height: 140px;
        min-height: 120px;
        width: 100%;
        vertical-align: baseline;
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-bottom: .5rem;
        &:hover {
            text-decoration: none;
            opacity: .8;
        }
        &.menu-1 {
            background-image: url(/img/top/menu01.jpg);
            border-radius: .3rem .3rem 0 0;
        }
        &.menu-2 {
            background-image: url(/img/top/menu02.jpg);
            margin-right: .3rem;
        }
        &.menu-3 {
            background-image: url(/img/top/menu03.jpg);
            margin-left: .3rem;
        }
        &.menu-4 {
            background-image: url(/img/top/menu04.jpg);
        }
        &.menu-5 {
            background-image: url(/img/top/menu05.jpg);
            margin-right: .3rem;
        }
        &.menu-6 {
            background-image: url(/img/top/menu06.jpg);
            margin-left: .3rem;
        }
        &.menu-7 {
            background-image: url(/img/top/menu07.jpg);
        }
        .menu-caption {
            font-size: 1.2rem;
            color: white;
            text-shadow: 0 0 5px rgba(0, 0, 0, .5);
            text-align: center;
        }
        .desc {
            font-size: .7rem;
            color: snow;
            text-align: center;
        }
    }
}
@media screen and (max-width: 575px) {
    .menu-outline {
        padding: 0;
        .menu {
            width: calc(100vw - 10px);
        }
    }
}
</style>

<script>
export default {
    computed: {
        isLoggedIn() {
            return this.$store.state.user?.id;
        },
    },
}
</script>